module.exports = __webpack_public_path__ + "img/facebook.ee6f29f.png";